import { Injectable } from '@angular/core';
import {
  ExternalpageService,
  externalpageTypes,
  externalpageImageTypes,
  externalpageStatuses
} from './externalpage.service';
import {Subject} from 'rxjs';
import {DomainService} from './domain.service';

@Injectable({
  providedIn: 'root'
})
export class PostService {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public relatedData: any[] = [];
  public $relatedDataSubject: Subject<any> = new Subject();

  constructor(
    public externalpageService: ExternalpageService,
    public domain:DomainService) {

  }

  /**
   * Set home data
   */
  setRelatedData() {

    if (this.relatedData.length == 0) {

      const $queryParams = {
        pageNumber: 1,
        pageSize: 24,
        PageStatus: externalpageStatuses.Published
      };

      this.externalpageService.apiGetExternalPageType(this.externalpageTypes.Post, $queryParams, this.domain.getCurrentRegion()).subscribe( (result: any) => {
        if (result && result.hasOwnProperty('data')) {
          this.relatedData = Object.assign([], result.data);

          if (this.relatedData.length > 0) {

            // Get all images of projects
            for (const i in this.relatedData) {
              this.relatedData[i]['imageUri'] = '';
              if (this.relatedData[i]['imageReferences']?.length > 0) {
                for (const image of this.relatedData[i]['imageReferences']) {
                  if (image['imageType'] == this.externalpageImageTypes.MainImage) {
                    this.relatedData[i]['imageUri'] = image['imageUri'];
                  }
                }
              }
            }
          }

          this.$relatedDataSubject.next(this.relatedData);

        }
      });
    }
  }
}
